import en_US from './en-US.json';

type translationsObject = {
  [key: string]: { [key: string]: string };
};

const translations: translationsObject = {
  en_US,
};

const TRANSLATION_REPLACEMENT_REGEX =
  // eslint-disable-next-line no-useless-escape
  /\{([\w\-]+)(?:\:([\w\.]*)(?:\((.*?)?\))?)?\}/g;

const objectReplacement =
  (obj?: Map<string, string>) => (prompt: string, variable: string) => {
    const value = obj?.get(variable);
    return value || '';
  };

export type Tr8 = (s: string, obj?: Map<string, string> | undefined) => string;

export const makeTr8 = (locale: string): Tr8 => {
  const tr8Object = translations?.[locale] || translations['en_US'];

  return function (s: string, obj?: Map<string, string>): string {
    const prompt = tr8Object?.[s] || '';

    return prompt
      ? prompt.replace(TRANSLATION_REPLACEMENT_REGEX, objectReplacement(obj))
      : '';
  };
};
